<template>
  <router-view></router-view>
</template>

<script>
    export default {
        name: "dosya"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Icra/dosya.vue